import { useEffect, useState } from "react"
import { useAuth } from "../../../../modules/auth"
import { useLazyGetExamSchedulesQuery } from "./properties/examscheduleApi"
import { IExamSchedule } from "./properties/examSchedule"
import { Spinner } from "../../../widgets"
import moment from "moment"
import { ControlType, Property, PropertyType } from "../../../base/types"
import { Registry } from "../../../base/register"
import { useGetCoursesName } from "./properties/useGetCoursesName";

export const ExamScheduleComponent = () => {
    const { user } = useAuth()
    const [fetchExamSchedules, { data: schedules = [], isLoading: isSchedulesLoading, isError }] =
        useLazyGetExamSchedulesQuery()
    const [fetchCount, setFetchCount] = useState(0)
    const { getCourseDetails, loading: isCoursesLoading } = useGetCoursesName();
    const isComponentLoading = isSchedulesLoading || isCoursesLoading;

    useEffect(() => {
        if (!user?.contactId) return

        fetchExamSchedules(user.contactId)
        const intervalId = setInterval(() => {
            if (fetchCount < 5) {
                fetchExamSchedules(user.contactId!)
                setFetchCount((prev) => prev + 1)
            } else {
                clearInterval(intervalId)
            }
        }, 5000)

        return () => clearInterval(intervalId)
    }, [user, fetchCount, fetchExamSchedules])

   
    const sortedSchedules = schedules
        ?.filter(exam => !!exam.isPublished) 
        .slice()
        .sort((a, b) => moment(a.startDate).isBefore(moment(b.startDate)) ? -1 : 1)

    return (
        <div className="p-4">
            {isComponentLoading && (
                <div className="text-center my-3">
                    <Spinner show={isComponentLoading} />
                </div>
            )}

            {!isComponentLoading && sortedSchedules && sortedSchedules.length > 0 ? (
                sortedSchedules.map((exam: IExamSchedule) => {
                    const courseDetails = getCourseDetails(exam.courseName);

                    return (
                        <div
                            key={exam.id}
                            className="card p-3 mb-3 border border-dark rounded"
                        >
                            <div className="row g-3 align-items-center">
                                <div className="col-12 col-lg-4">
                                    <strong>Course Name:</strong>
                                    <br />
                                    <span className="text-dark"> {courseDetails.name}</span>
                                </div>

                                <div className="col-6 col-lg-2">
                                    <strong>Course Code:</strong>
                                    <br />
                                    <span className="text-dark">{courseDetails.code}</span>
                                </div>

                                <div className="col-6 col-lg-2">
                                    <strong>Start Date:</strong>
                                    <br />
                                    {exam.startDate && moment(exam.startDate).isValid()
                                        ? moment(exam.startDate).format("DD MMM YYYY")
                                        : "Invalid date"}
                                </div>
                                <div className="col-6 col-lg-2">
                                    <strong>Start Time:</strong><br />
                                    {exam.startDate && moment.utc(exam.startDate).isValid()
                                        ? moment.utc(exam.startDate).utcOffset("+05:30").format("hh:mm A")
                                        : "Invalid time"}
                                </div>

                                <div className="col-6 col-lg-2">
                                    <strong>End Time:</strong><br />
                                    {exam.endDate && moment.utc(exam.endDate).isValid()
                                        ? moment.utc(exam.endDate).utcOffset("+05:30").format("hh:mm A")
                                        : "Invalid time"}
                                </div>
                            </div>
                        </div>
                    );
                })
            ) : (
                !isComponentLoading && (
                    <div className="mt-5 text-center text-muted">
                        No upcoming exams found.
                    </div>
                )
            )}
        </div>
    )
}

Registry.addControl({
    id: "85ee9f0b-a3aa-43d9-a376-dabddb56c97d",
    name: "Exam Schedule Component",
    type: ControlType.ExamScheduleComponent,
    properties: [
        { id: Property.Tooltip, name: "Tooltip", type: PropertyType.String },
        { id: Property.Label, name: "Navigate Label", type: PropertyType.String },
    ],
    component: ExamScheduleComponent,
})
